import { z } from 'zod';

/** Opaque `#RRGGBB` only, so nothing else can reach a CSS property. */
const hex = z.string().regex(/^#[0-9a-fA-F]{6}$/);
const px = (max: number) => z.number().int().min(0).max(max);

/**
 * How a flow brand styles embedded Ronan's card and drawer (RFC 20261021a):
 * the shadcn tokens charlie reads, plus the brand colour, the button radius
 * and the card's border width. A row is always complete.
 */
export const embeddedAppearanceSchema = z.object({
  background: hex,
  foreground: hex,
  card: hex,
  muted: hex,
  mutedForeground: hex,
  accent: hex,
  accentForeground: hex,
  primary: hex,
  primaryForeground: hex,
  border: hex,
  destructive: hex,
  brandPrimary: hex,
  radius: px(24),
  buttonRadius: px(24),
  borderWidth: px(3),
});

export type EmbeddedAppearance = z.infer<typeof embeddedAppearanceSchema>;

/**
 * The appearance when it is valid. An invalid one is dropped as a whole, so
 * the card keeps the default look rather than a mix.
 */
export function parseEmbeddedAppearance(
  raw: unknown,
): EmbeddedAppearance | undefined {
  if (raw == null) return undefined;
  const parsed = embeddedAppearanceSchema.safeParse(raw);
  if (parsed.success) return parsed.data;
  console.warn(
    '[Ronan] Ignoring the embedded appearance, it has invalid values:',
    parsed.error.issues.map((issue) => issue.path.join('.')).join(', '),
  );
  return undefined;
}
